module.exports = __webpack_public_path__ + "img/mx.37507196.svg";